export default __webpack_public_path__ + "static/media/Terezin_sm.ebbccc99.jpg";